//for IE, Edge polyfill
import smoothscroll from 'smoothscroll-polyfill';
import objectFitImages from 'object-fit-images';
import Swiper from 'swiper';
import $ from 'jquery';

objectFitImages();


// baguetteBox = require('baguettebox.js');

// axios を require してインスタンスを生成する
var axiosBase = require('axios');
var axios = axiosBase.create({
  baseURL: '', // バックエンドB のURL:port を指定する
  headers: {
    'ContentType': 'text/html',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'text'
});

import './_novel.js'

//LINE送るボタン
LineIt.loadButton();

$(function(){

  $('.toggleButton').on('click',function(){
    $(this).parent().toggleClass('toggleOpen');
    return false;
  });
  $('.post-share .navBtn').on('click',function(){
    $('.toggleOpen').removeClass('toggleOpen');
    return false;
  });
  $('#copyUrlButton').on('click', function(){
    var text = document.getElementById('copyUrlText');
    var range = document.createRange();
    range.selectNode(text);
    window.getSelection().addRange(range);
    document.execCommand('copy');
    alert('URLをコピーしました');
  });

	$(document).on('click','#homeReadMoreButton',function(){
		$(this).text('記事を読み込んでいます…');
    var $target = $(this);
		// console.log('href', $(this).attr('href'));
		axios.get($(this).attr('href'))
		.then(function(response) {
			$target.hide();
			if(response.data == ''){
				window.alert('すべての記事を読み込みました。');
			}
			$('#homePostCalendar').append(response.data);
		  //console.log('index', response);
			$target.text('続きを見る');
		})
		.catch(function(error) {
		  console.log('ERROR!! happend by Backend.');
		});
		return false;
	});

	$('#globalNavBtnOpen').on('click',function(){
		$('#globalNav,#modalShadow').addClass('nav-open');
 		ga('send', 'event', 'Menu', 'menu open');
	});
	$('#globalNavBtnClose,#modalShadow').on('click',function(){
		$('#globalNav,#modalShadow').removeClass('nav-open');
		ga('send', 'event', 'Menu', 'menu close');
	});
	$('#dd_button').on('click',function(){
		if($('#ddsearch_container').hasClass('active')){
			$('#ddsearch_container').removeClass('active');
		}else{
			$('#ddsearch_container').addClass('active');
			document.activeElement.blur();
			document.getElementById('s').focus();
		}
		return false;
	});
	$('#textSearchBtnClose').on('click',function(){
		$('#dd_button').trigger('click');
		return false;
	});


		$('#side_button').on('click',function(){
			if($('#sidesearch_container').hasClass('active')){
				$('#sidesearch_container').removeClass('active');
			}else{
				$('#sidesearch_container').addClass('active');
				document.activeElement.blur();
				document.getElementById('s').focus();
			}
			return false;
		});
		$('#SearchBtnClose').on('click',function(){
			$('#side_button').trigger('click');
			return false;
		});
//	if(!$('#home').length){
		var seasons_swiper = new Swiper('#seasons', {
			paginationClickable:true,
			navigation: {
		    nextEl: '.swiper-next',
		    prevEl: '.swiper-prev',
		  },
			slidesPerView:'auto'
		});

		this.backnumbers_swiper = new Swiper('#backnumbers', {
			// speed: 500,
			paginationClickable:true,
			navigation: {
			    nextEl: '.swiper-next',
			    prevEl: '.swiper-prev',
		  },
			slidesPerView: 'auto',
			breakpoints: {
				640: { slidesPerView: 4, },
				768: { slidesPerView: 8, },
				1024: { slidesPerView: 12, }
		  }
		});

		this.home_swiper = new Swiper('#home', {
			speed: 500,
			navigation: {
			    nextEl: '.swiper-button-next',
			    prevEl: '.swiper-button-prev',
		  },
			autoplay: {
				delay: 4500
			},
			// slidesPerView: 5,
			loop: true,
			paginationClickable:true,
			// breakpoints: {
			// 	640: { slidesPerView: 2, },
			// 	768: { slidesPerView: 3, },
			// 	1024: { slidesPerView: 4, }
		  // },
			pagination:{
				el: '.swiper-pagination',
				clickable: true,
			}
		});

		$('.plus-icon').on('click',function(){
			var group = this.dataset.group; // data-groupの属性を獲得する
			var dropdown = this.dataset.dropdown; // data-dropdownの属性を獲得する
			$('#globalNav .'+group).not('.'+dropdown).removeClass('open');
			$('#globalNav .'+dropdown).toggleClass('open');
		});

});
